import { render, staticRenderFns } from "./pipe-event.vue?vue&type=template&id=40d96598&scoped=true"
import script from "./pipe-event.vue?vue&type=script&lang=js"
export * from "./pipe-event.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d96598",
  null
  
)

export default component.exports